module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('form', {
    staticClass: "shaded",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.processForm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_c('span', [_vm._v("Your first and last name")]), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Please add your name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Your first and last name are required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Your first and last name must have at least 4 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Company brand name"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.brand),
      expression: "form.brand"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Company brand name"
    },
    domProps: {
      "value": (_vm.form.brand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "brand", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.brand.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.brand.required) ? _c('span', [_vm._v("Company brand name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.brand.minLength) ? _c('span', [_vm._v("Your company brand must have at least 3 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Company Address"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyAddress),
      expression: "form.companyAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Company Address"
    },
    domProps: {
      "value": (_vm.form.companyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.companyAddress.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.companyAddress.required) ? _c('span', [_vm._v("Company Address is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            ZIP-Code"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zipCode),
      expression: "form.zipCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ZIP-Code"
    },
    domProps: {
      "value": (_vm.form.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "zipCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.zipCode.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.zipCode.required) ? _c('span', [_vm._v("ZIP-Code is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_vm._m(0), _vm._v(" "), _c('country-picker', {
    attrs: {
      "openDirection": 'top',
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event)
      }
    }
  }), _vm._v(" "), (_vm.$v.form.country && _vm.$v.form.country.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.country.required) ? _c('span', [_vm._v("Country is required.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Location"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.location),
      expression: "form.location"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Location"
    },
    domProps: {
      "value": (_vm.form.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.location.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.location.required) ? _c('span', [_vm._v("Location is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            VAT Number"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.vatNumber),
      expression: "form.vatNumber"
    }],
    attrs: {
      "type": "text",
      "placeholder": "VAT"
    },
    domProps: {
      "value": (_vm.form.vatNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "vatNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.vatNumber.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.vatNumber.required) ? _c('span', [_vm._v("VAT Number is required.")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Email"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.email.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.email.email) ? _c('span', [_vm._v("Must be a valid email")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Password"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "Your password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.password.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.password.required) ? _c('span', [_vm._v("Please type a password.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.password.minLength) ? _c('span', [_vm._v("Minimum length of 6 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller mt-5 mb-1"
  }, [_c('checkbox', {
    staticClass: "d-inline",
    attrs: {
      "name": "terms",
      "value": "true"
    },
    model: {
      value: (_vm.form.hasAcceptTermsConditions),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasAcceptTermsConditions", $$v)
      },
      expression: "form.hasAcceptTermsConditions"
    }
  }), _vm._v("\n                I accept the\n                "), _c('span', {
    staticClass: "darker underlined pointer",
    on: {
      "click": _vm.openConditions
    }
  }, [_vm._v("Terms of Service and Privacy Policy")])], 1), _vm._v(" "), _c('input', {
    staticClass: "btn action widest full",
    attrs: {
      "type": "submit",
      "value": "Sign up free",
      "disabled": _vm.$v.form.$invalid
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Country"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6b59d8e3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b59d8e3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/supplier/Step1.vue
// module id = 2648
// module chunks = 0